var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgVectorLeft = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 476,
    viewBox: "0 0 143 476",
    width: 143,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-243.663 421.281c106.349 86.12 250.76094 66.634 333.0684-35.007 82.3076-101.641 69.0266-269.633-35.007-333.0686-104.0336-63.4354-257.2544-87.5813-333.0684 35.0069-75.815 122.5887-71.342 246.9487 35.007 333.0687z",
    fill: "#2e933c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-243.663 421.281c106.349 86.12 250.76094 66.634 333.0684-35.007 82.3076-101.641 69.0266-269.633-35.007-333.0686-104.0336-63.4354-257.2544-87.5813-333.0684 35.0069-75.815 122.5887-71.342 246.9487 35.007 333.0687z",
    fill: "#000",
    fillOpacity: 0.2
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgVectorLeft);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/vectorLeft.d522c183a69ea6a28e01b0112c403428.svg";